<template></template>
<script>
export default {
  props: {
    sskey: {
      type: String,
      default: null
    },
    ssvalue: {
      type: String,
      default: null
    }
  },
  mounted() {

    if (this.sskey.length > 0) {
      if (this.ssvalue.length > 0) {

        if (this.ssvalue === "remove") {
          sessionStorage.removeItem(this.sskey);
        } else {
          sessionStorage.setItem(this.sskey, this.ssvalue);
        }
      }
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
